import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Back Teaser",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-back-teaser",
    argTypes: {
        intro: {
            description: "Top Intro text for the teaser",
            control: {
                type: "text",
            },
        },
        text: {
            description:
                "Text that will be placed before the title of the linked Page",
            control: {
                type: "text",
            },
        },
    },
    args: {
        intro: "Zurück zur letzten Seite",
        text:
            "Sie wollen sich den vorherigen Inhalt noch einmal anschauen? Hier gelangen Sie wieder zur Seite",
    },
};

const Template = ({ intro, text }) => html`
    <div class="ux-row">
        <ol>
            <li>Accept Cookies</li>
            <li>
                Load this Story again and the data should be saved
                automatically.
            </li>
            <li>
                Next time you load the story, the Teaser should be displayed.
            </li>
        </ol>
        <ux-iws-back-teaser-save></ux-iws-back-teaser-save>
        <ux-iws-back-teaser
            intro="${intro}"
            text="${text}"
        ></ux-iws-back-teaser>
    </div>
`;

export const Default = Template.bind({});
